<template>
  <div class="detailHeader">
    <div class="leftHeader">
      <i :class="iconArr[resultMsg.typeId-1]"></i>
      <span>{{resultMsg.keycode}}</span>
      <span>{{resultMsg.scopeName+'/'}}</span>
      <span>{{resultMsg.unit_text}}</span>
    </div>
    <v-tab :tabsArray="tabsArray" :activeName="activeName" :isHeight="isHeight" />
  </div>
</template>

<script>
import tab from '../Tabs.vue'
export default {
  props: ['resultMsg'],
  components: {
    'v-tab': tab
  },
  data() {
    return {
      isHeight: true,
      activeName: '1',
      tabsArray: [
        {
          id: 1,
          label: 'labelTitle.Carrier Information',
          sortNum: '1'
        },
        {
          id: 2,
          label: 'labelTitle.DeviceBinding',
          sortNum: '2'
        },
        {
          id: 3,
          label: 'tableTitle.ExceptionRecord',
          sortNum: '3'
        },
        {
          id: 4,
          label: 'labelTitle.Operation History',
          sortNum: '4'
        },
      ],
      iconArr: [
        'iconfont icon-weibolu-xian',
        'iconfont icon-bingxiang',
        'iconfont icon-qiche',
        'iconfont icon-9lengku',
      ], //保温箱 冰箱 车辆 冷库
    }
  }
}
</script>

<style lang="scss" scoped>
.detailHeader {
  background-color: #fff;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
  box-sizing: border-box;
  .leftHeader{
    i{
      font-size: 16px;
      margin-right: 10px;
    }
    span{
      font-size: 16px;
      margin-right: 10px;
    }
  }
}
</style>